import { createGlobalStyle } from 'styled-components';
import { colorSchema } from '@ontruck/orc';
import { beamerStyles } from 'analytics/beamer';
import { tenantStyles } from 'tenant/utils';

function convertOrcColorsToCSSVariables() {
  const entries = Object.entries(colorSchema);

  return entries.reduce((acc, current) => {
    const [key, value] = current;
    return { ...acc, [`--${key}`]: value };
  }, {});
}

const GenericGlobalStyles = createGlobalStyle`

  html, body {
    overflow: hidden;
    height: 100%;
    width: 100%;
    line-height: 1.2;
  }

  #root{
    height: 100%;
  }

  @media print {
    html, body {
      overflow: auto;
      height: auto;
      width: auto;
    }
  }

  input::-webkit-contacts-auto-fill-button {
    visibility: hidden;
    display: none !important;
    pointer-events: none;
    position: absolute;
    right: 0;
  }
  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: none;
  }

  :root {
    ${convertOrcColorsToCSSVariables()}
    --primary50: #F0F5FF;
    --primary10: #6797FE;
    --deep-purple900: #9a11b3;
    --deep-purple700: #cc1fea;
    --deep-purple500: #e484f5;
    --deep-purple300: #f1bdfa;
    --deep-purple100: #fbecfd;
    --deep-purple500: #9a11b3;
    --success100: #e9ffd6;
    --success300: #c9fe9a;
    --error-100: #ffe0e2;
    --error-300: #fdafb3;
    --error-500: #fc737a;
    --error-700: #fc030f;
    --error-900: #cc000a;
    --greenKiwi: #8ed267;
    --grey100-opacity50: #F8FAFB;
    --primary-300-opacity10: #1A53D2;
    --primary-200-opacity30: #537FE0;
    --primary900: #002575;
    --primary700: #013198;
    --primary500: #0140CD;
    --primary300: #6797fe;
    --primary200: #C2D5FF;
    --primary100: #e0eaff;
    --primary-btn500: #0140CD;
    --primary-btn300: #6797fe;
    --primary-btn-main-menu: rgba(103, 151, 254, 0.8);
    --accent-color-blue: #2396DC;
    --primary-background: #fff;
 }
  ${beamerStyles}
`;

const TenantGlobalStyles = createGlobalStyle`
	${tenantStyles}
`;

const GlobalStyles = () => {
  return (
    <>
      <GenericGlobalStyles />
      <TenantGlobalStyles />
    </>
  );
};

export default GlobalStyles;
